import React, { useContext } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string, number } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({
  pipTimeout,
  prefetchPip,
  productPodHoverDelay
}) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={routes.browse.path}>
          {channel === 'mobile'
            // eslint-disable-next-line max-len
            ? <routes.browseMobile.component pageType="browse" prefetchPip={prefetchPip} productPodHoverDelay={productPodHoverDelay} />
            // eslint-disable-next-line max-len
            : <routes.browse.component pageType="browse" prefetchPip={prefetchPip} productPodHoverDelay={productPodHoverDelay} />}
        </Route>
        <Route path={routes.search.path}>
          {channel === 'mobile'
            // eslint-disable-next-line max-len
            ? <routes.searchMobile.component pageType="search" prefetchPip={prefetchPip} productPodHoverDelay={productPodHoverDelay} />
            // eslint-disable-next-line max-len
            : <routes.search.component pageType="search" prefetchPip={prefetchPip} productPodHoverDelay={productPodHoverDelay} />}
        </Route>
        <Route exact path={routes.package.path}>
          <routes.package.component />
        </Route>
        <Route exact path={routes.product.path}>
          {channel === 'mobile' ? <routes.productMobile.component pipTimeout={pipTimeout} />
            : <routes.product.component pipTimeout={pipTimeout} />}
        </Route>
        <Route exact path={routes.compare.path}>
          <routes.compare.component />
        </Route>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  pipTimeout: string,
  prefetchPip: string,
  productPodHoverDelay: number
};

App.defaultProps = {
  pipTimeout: null,
  prefetchPip: null,
  productPodHoverDelay: 500
};
